<div>
    <div class="pt-[30px] w-full">
        <span class="text-[20px] font-[DMSans] text-[rgba(74,74,74,1)] font-bold">Never miss a bid! </span>
        <span class="text-[20px] font-[DMSans] text-[rgba(74,74,74,1)] ">Tap “Create a Saved Search” to save your preferences and get up to one email a day when new items match.</span>
    </div>
    <div class="text-[20px] font-[DMSans] text-[rgba(74,74,74,1)] pt-[30px] w-full">Uncheck the box to stop alerts, and visit My Searches anytime for updates.</div>   
    
    <div *ngIf="this.mySearchesList==null" class="flex justify-center items-center h-[245px]">
        <p-progress-spinner ariaLabel="loading" />
    </div>
    <div *ngIf="this.mySearchesList!=null && this.mySearchesList!.length == 0" class="flex justify-center items-center h-[245px]">
        <p-card class="text-center font-[DMSans] text-[16px] font-bold shadow-xl shadow-cyan-500/5">
            <p>
                You have no saved searches. 
            </p>
        </p-card> 
    </div>
    <div *ngIf="this.mySearchesList!=null && this.mySearchesList.length>0">
        <div class="grid lg:grid-cols-4 grid-cols-5 h-[26px] mb-[19px] mt-[30px]">
            <div class="row lg:col-span-2 col-span-3 flex items-center text-[20px] font-bold">
                Search Criteria
            </div>
            <div class="flex justify-center items-center">
                <fa-icon [icon]="faEnvelope" class="text-[26px] "></fa-icon>
            </div>
            <div class="lg:flex hidden justify-center items-center text-[20px] font-bold">
                Remove
            </div>

        </div>
        <div class="h-[1px] w-full bg-[rgba(223,231,239,1)]"></div>
        <p-table class="hidden lg:block" ngSkipHydration
            [value]="this.mySearchesList!"
            [paginator]="this.mySearchesList!.length>10"
            [rows]="10"
            (onPageChange)="this.onPageChange($event)"
            >
            <ng-template #body let-search>
                <app-search-item
                    (confirm)="confirm($event)"
                    [search]="search">
                </app-search-item>
            </ng-template>
        </p-table>

        <div class="block lg:hidden">
            @for (search of this.mySearchesList!; track $index) {
                <app-search-item
                    (confirm)="confirm($event)"
                    [search]="search">
                </app-search-item>
            }
        </div>
        

    </div>
    
    <p-scrolltop class="flex lg:hidden custom-scroll-top"/>

</div>
